import { waitForRef } from './ComponentUtils';

/**
 * Given a component that renders <li> elements
 * When the last <li> element is close to the bottom of the viewport
 * Then call the fetchMoreItems callback
 * And if more items are returned
 * Then fetch more items when the new last <li> element is close to the bottom of the viewport.
 */
export default {
  data() {
    return {
      lastItem: null,
      limit: 20,
      observer: null,
      skip: 0,
    };
  },

  unmounted() {
    this.removeIntersectionObserver();
  },

  methods: {
    async addIntersectionObserver(ref, fetchMoreItems) {
      if (typeof ref === 'string') {
        await waitForRef(this, ref);
      }

      // Use :scope pseudo class so that only list items that are direct children of the <ul> are
      // used for checking when to fetch more locations.
      // SEE: https://developer.mozilla.org/en-US/docs/Web/CSS/:scope
      const selector = ':scope > li:last-child';

      if (typeof ref === 'string') {
        this.lastItem = this.$refs[ref].querySelector(selector);
      }
      else {
        this.lastItem = ref.querySelector(selector);
      }

      if (!this.observer) {
        const options = {
          rootMargin: '0px 0px 200px 0px',
          threshold: 0,
        };

        this.observer = new IntersectionObserver(
          (entries) => this.handleLastItemVisible(entries, ref, fetchMoreItems),
          options,
        );
      }

      this.observer.observe(this.lastItem);
    },

    async handleLastItemVisible(entries, ref, fetchMoreItems) {
      if (entries && entries.length) {
        if (entries[0].isIntersecting) {
          if (!this.observer) {
            // Just return if the callback is triggered after the observer was removed when the
            // page is unmounted.
            return;
          }

          this.skip += this.limit;
          const itemsReturned = await fetchMoreItems();
          this.observer.unobserve(this.lastItem);

          if (itemsReturned) {
            this.addIntersectionObserver(ref, fetchMoreItems);
          }
        }
      }
    },

    removeIntersectionObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    },
  },
};
